import { ChatIcon } from './Icons.jsx';

/**
 * Bottom-right of the merchant admin. 58px, icon only, no pulse when idle.
 *
 * The badge counts unread and nothing else. It used to take a second, louder
 * form when the unread message carried an agent alert, which told the visitor
 * something the visitor is not meant to be able to tell.
 */
export function Launcher({ unread, onOpen, brand }) {
  const label = unread > 0 ? `Open ${brand} — ${unread} unread` : `Open ${brand}`;

  return (
    <div class="launcher">
      <button class="launcher__button" type="button" onClick={onOpen} aria-label={label}>
        <ChatIcon size={24} />
      </button>
      {unread > 0 && (
        <div class="launcher__badge" aria-hidden="true">
          {unread > 99 ? '99+' : unread}
        </div>
      )}
    </div>
  );
}

export default Launcher;
